export const FETCH_WEEKS_REQUEST = 'FETCH_WEEKS_REQUEST';
export const FETCH_WEEKS_SUCCESS = 'FETCH_WEEKS_SUCCESS';
export const FETCH_WEEKS_FAILURE = 'FETCH_WEEKS_FAILURE';
export const FETCH_MONTHS_REQUEST = 'FETCH_MONTHS_REQUEST';
export const FETCH_MONTHS_SUCCESS = 'FETCH_MONTHS_SUCCESS';
export const FETCH_MONTHS_FAILURE = 'FETCH_MONTHS_FAILURE';
export const FETCH_QUATER_REQUEST = 'FETCH_QUATER_REQUEST';
export const FETCH_QUATER_SUCCESS = 'FETCH_QUATER_SUCCESS';
export const FETCH_QUATER_FAILURE = 'FETCH_QUATER_FAILURE';
